import React from 'react';
import { Link } from 'react-router-dom';
import t from '~t';
import { useSelector, useDispatch } from 'react-redux';
import { cancel, parcelSave } from '~data/actions/import';

import { Error, Confirm } from '~co/overlay/dialog';
import { Button, ButtonRow, Label, Progress, Alert, Icon, Preloader } from '~ui';

export default function ImportParcel() {
  const mode = useSelector((state) => state.import.mode);
  const file = useSelector((state) => state.import.file);
  const status = useSelector((state) => state.import.parcel.status);
  const progress = useSelector((state) => state.import.parcel.progress);
  const dispatch = useDispatch();

  const onStartClick = async () => {
    if (
      mode == 'from_scratch' &&
      !(await Confirm(t.s('startFromScratch') + '?', {
        description: t.s('startFromScratchD'),
      }))
    )
      return;

    dispatch(parcelSave(undefined, Error));
  };

  const max = file.count.bookmarks + file.count.folders;
  const value = progress.bookmarks + progress.folders;

  const renderProgress = (children) => (
    <Progress
      min='0'
      max={max}
      value={value}
      valueText={`${parseInt((100 / max) * value)}%`}
    >
      {children}
    </Progress>
  );

  if (file.status != 'loaded') return null;

  switch (status) {
    case 'loading':
      return (
        <>
          <Label>
            <Preloader />
          </Label>

          {renderProgress(
            <>
              <b>{t.s('importing')}</b>. {t.s('importingInfo2')}
            </>,
          )}
        </>
      );

    case 'success':
      return (
        <>
          <div />

          <Alert variant='success'>
            <b>{t.s('importEnd')}</b>
            <br />
            {t.s('importIsProcessing')} {t.s('importIsProcessingDD')}
          </Alert>

          <ButtonRow>
            <Button asChild variant='default'>
              <Link to='/'>
                <Icon name='check_active' />
                {t.s('goHome')}
              </Link>
            </Button>

            <Button variant='outline' onClick={() => dispatch(cancel())}>
              <Icon name='refresh' />
              {t.s('selectOtherFile')}
            </Button>
          </ButtonRow>
        </>
      );

    case 'error':
      return (
        <>
          <div />

          {renderProgress(
            <Alert variant='danger'>
              <b>{t.s('fileUploadError')}</b>
            </Alert>,
          )}

          <ButtonRow>
            <Button variant='outline' onClick={() => dispatch(cancel())}>
              <Icon name='refresh' />
              {t.s('tryAgain')}
            </Button>
          </ButtonRow>
        </>
      );

    default:
      return (
        <ButtonRow>
          <Button variant='default' onClick={onStartClick}>
            <Icon name='import_active' />
            {t.s('startImport')}
          </Button>

          <Button variant='outline' onClick={() => dispatch(cancel())}>
            <Icon name='refresh' />
            {t.s('selectOtherFile')}
          </Button>
        </ButtonRow>
      );
  }
}
